import { Provider } from "jotai";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import useManagers from "../../../../hooks/useManagers/useManagers";
import useRole from "../../../../hooks/useRole/useRole";
import useTasks from "../../../../hooks/useTasks/useTasks";
import usePanneauLeads from "../../../common/CarteLead/usePanneauLeads";
import Loader from "../../../common/Loader";
import useDocumentList from "../../DocumentList/useDocumentList";
import LeadListFilters from "../LeadListFilters/LeadListFilters";
import useLeads from "../useLeads";
import { LeadContext } from "./LeadContext";
import LeadCount from "./LeadCount/LeadCount";
import LeadItem from "./LeadItem/LeadItem";
import { ONGLETS_PAR_CATEGORIE } from "./LeadItem/profilLead";
import LeadListPagination from "./LeadListPagination/LeadListPagination";
import "./leadList.scss";

const queryString = require("query-string");

// Liste des leads entreprise ou DOMI : filtres, pagination, cartes du kit
// commun et panneau de détail (un seul lead ouvert pour toute la liste).
const LeadList = () => {
  const { leads, actions, leadCount, isSearching, isListInit, productCategory } = useLeads();
  const { tasksByProduct } = useTasks();
  const { managers, contacts } = useManagers(true);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const { myRole } = useRole();
  const { initFileTypes, fileTypes } = useDocumentList();
  // Tant que la liste n'est pas chargée, le panneau ne connaît pas de leads :
  // l'adresse (#panneau=…) est relue une fois la liste là.
  const panneau = usePanneauLeads(isListInit ? leads : null, ONGLETS_PAR_CATEGORIE[productCategory]);

  useEffect(() => {
    initFileTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (managers.length) {
      setIsLoading(false);
      const parsed = queryString.parse(location.search, { arrayFormat: "bracket" });
      let newLeadFilters = null;
      if (Object.values(parsed).length > 0) {
        newLeadFilters = parsed;
      }
      actions.resetAtoms({ newLeadFilters });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managers, location.search]);

  return isLoading ? (
    <Loader />
  ) : (
    <StyledLeadList>
      <LeadListFilters />
      <LeadListPagination leadCount={leadCount} />
      <LeadCount />
      <p className="text-center">Seules les demandes validées sont affichées</p>
      {isSearching ? (
        <Loader />
      ) : (
        leads.map((lead) => (
          <div className="leadListCard la-conteneur" key={`lead${lead.id}`}>
            <LeadContext.Provider
              value={{
                tasksByProduct: tasksByProduct[lead.productId],
                managers,
                contacts,
                myRole,
                fileTypes,
                panneau,
              }}
            >
              <Provider>
                <LeadItem data={lead} />
              </Provider>
            </LeadContext.Provider>
          </div>
        ))
      )}
      <LeadListPagination leadCount={leadCount} />
    </StyledLeadList>
  );
};

export const StyledLeadList = styled.div``;

export default LeadList;
